<template lang="html">

  <section class="register">
    <v-content>
      <h1 class="mb-5 mt-5">Passwort vergessen</h1>
      <v-form v-model="valid" ref="form">
        <v-text-field outlined v-model="email" label="E-Mail" :rules="[rules.required, rules.mail]"
                      validate-on-blur></v-text-field>
        <p class="red--text" v-for="message in errorMessages" v-bind:key="message">{{ message }}<br></p>
        <v-btn @click="register" class="button">Neues Passwort anfordern</v-btn>
      </v-form>
    </v-content>
  </section>

</template>

<script lang="js">
import Vue from 'vue';
import AuthService from "../../services/AuthService";
import VueRouter from 'vue-router';

Vue.use(VueRouter);
export default {
  name:  'register',
  props: [],
  mounted () {
  },
  data () {
    return {
      'email':       "",
      show:          false,
      errorMessages: [],
      valid:         false,
      rules:         {
        required:   value => !!value || 'Diese Feld wird benötigt.',
        min:        v => v.length >= 8 || 'Mindestens 8 Zeichen',
        mail:       v => /.+@.+\..+/.test(v) || 'Bitte gib eine gültige E-Mail ein',
        emailMatch: v => v === this.password || ('Die E-Mail und das Passwort stimmen nicht überein'),
      },
    }
  },
  methods:  {
    register () {
      this.errorMessages = [];
      if (this.valid) {
        let formData = new FormData();
        formData.append('email', this.email);

        AuthService.forgotPassword(formData)
                   .then(res => {
                     console.log(res);
                     this.$router.push('/login');
                   })
                   .catch(err => {
                     const errors = Object.values(err.response.data.errors);
                     errors.forEach(errorCategory => {
                       errorCategory.forEach(error => {
                         this.errorMessages.push(error);
                       });
                     });
                   });
      } else {
        this.$refs.form.validate();
      }
    },
  },
  computed: {}
}


</script>

<style scoped lang="scss">
.register {

}
</style>
